var render = function render() {
  var _vm$adsInfo, _vm$feedInfo, _vm$feedInfo2, _vm$feedInfo3, _vm$feedInfo4;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "micro-note"
  }, [_c('operateDom', {
    attrs: {
      "index": _vm.microIndex
    }
  }), _vm.visibleMicroFeed ? _c('div', [_vm.isShowHiddenDom ? _c('hidden-dom', {
    attrs: {
      "index": _vm.microIndex
    },
    on: {
      "title-show": _vm.titleShow
    }
  }) : _vm._e(), _c('observe-dom', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0"
    },
    attrs: {
      "index": _vm.microIndex,
      "data-item": _vm.feedInfo,
      "type": "top"
    }
  }), _c('microFeed', {
    attrs: {
      "item": _vm.feedInfo,
      "feed-index": _vm.microIndex,
      "new-btn-icon": _vm.newBtnIcon
    },
    on: {
      "content-open": _vm.contentOpen,
      "open-Baidu-Map": _vm.jumpToMap
    }
  })], 1) : _vm._e(), _c('div', {
    class: {
      'space-compress-fold': _vm.microIndex === 0,
      'un-space-compress-fold': _vm.showSpaceCompressFoldPart
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('observe-dom', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0"
    },
    attrs: {
      "index": _vm.microIndex,
      "data-item": _vm.feedInfo,
      "type": "end"
    }
  }), _vm.microIndex > 0 || _vm.feedInfo.tpSource !== 'push' && _vm.feedInfo.aiPush !== 'ai_tourist_guide' ? [_vm.isShowConsultsCard ? _c('consultsCard', {
    staticClass: "consult-container",
    attrs: {
      "consult-obj": (_vm$adsInfo = _vm.adsInfo) === null || _vm$adsInfo === void 0 ? void 0 : _vm$adsInfo.ext,
      "poi-list": (_vm$feedInfo = _vm.feedInfo) === null || _vm$feedInfo === void 0 || (_vm$feedInfo = _vm$feedInfo.mentioned) === null || _vm$feedInfo === void 0 ? void 0 : _vm$feedInfo.content,
      "source": _vm.source
    }
  }) : _vm._e(), _vm.poiCardLink && !_vm.isEmpty && !_vm.isHarmony ? _c('poiCard', {
    key: _vm.microIndex,
    staticClass: "poi-card-warpper",
    attrs: {
      "poi-link": _vm.poiCardLink,
      "poi-list": (_vm$feedInfo2 = _vm.feedInfo) === null || _vm$feedInfo2 === void 0 || (_vm$feedInfo2 = _vm$feedInfo2.mentioned) === null || _vm$feedInfo2 === void 0 ? void 0 : _vm$feedInfo2.content,
      "unique_id": (_vm$feedInfo3 = _vm.feedInfo) === null || _vm$feedInfo3 === void 0 ? void 0 : _vm$feedInfo3.unique_id,
      "source": _vm.source,
      "abtest": _vm.abtest
    }
  }) : _vm._e(), !_vm.poiCardLink ? _c('poiLine', {
    staticClass: "poi-line-new",
    attrs: {
      "feed-item": _vm.feedInfo,
      "poi-list": (_vm$feedInfo4 = _vm.feedInfo) === null || _vm$feedInfo4 === void 0 || (_vm$feedInfo4 = _vm$feedInfo4.mentioned) === null || _vm$feedInfo4 === void 0 ? void 0 : _vm$feedInfo4.content,
      "data-index": _vm.microIndex,
      "unique_id": _vm.feedInfo.unique_id
    },
    on: {
      "open-Baidu-Map": _vm.jumpToMap
    }
  }) : _vm._e(), _vm.isShowCouponCard ? _c('couponCard', {
    staticClass: "food-poi-list-vote",
    attrs: {
      "sku-data": _vm.feedInfo.skuData,
      "unique_id": _vm.feedInfo.unique_id
    },
    on: {
      "open-Baidu-Map": _vm.jumpToMap
    }
  }) : _vm._e(), _vm.isShowCouponListCard ? _c('couponListCard', {
    staticClass: "food-coupon-list",
    attrs: {
      "sku-data-list": _vm.feedInfo.skuDataList,
      "unique_id": _vm.feedInfo.unique_id,
      "tp-source": _vm.feedInfo.tpSource
    },
    on: {
      "open-Baidu-Map": _vm.jumpToMap
    }
  }) : _vm._e(), _vm.isEmpty && !_vm.isShowConsultsCard ? _c('poiOldFriend', {
    staticClass: "food-coupon-list",
    attrs: {
      "ads-info": _vm.adsInfo
    }
  }) : _vm._e(), _vm.relatedMentioned(_vm.feedInfo) ? _c('relatedSearch', {
    attrs: {
      "recommend-info": _vm.feedInfo.mentioned.content[0].recommend_info
    },
    on: {
      "searchClick": _vm.searchClick,
      "showSearchPV": _vm.showSearchPV
    }
  }) : _vm._e(), _vm.isHotspotShow && _vm.hotInfoShow && !_vm.isShowConsultsCard ? _c('div', {
    staticClass: "hot-info"
  }, [_c('hotInfo', {
    attrs: {
      "info": _vm.feedInfo.hotspot
    },
    on: {
      "open-Baidu-Map": _vm.jumpToMap
    }
  })], 1) : _vm._e()] : _vm._e(), !_vm.isBaiduMapAuto && _vm.feedInfo.aiPush !== 'ai_tourist_guide' ? _c('div', [_c('microBottomList', {
    attrs: {
      "jump-wx-app-url": _vm.jumpWxAppUrl,
      "micro-index": _vm.microIndex,
      "new-btn-icon": _vm.newBtnIcon,
      "item": _vm.feedInfo
    },
    on: {
      "open-share": _vm.updateWxShare,
      "open-Baidu-Map": _vm.jumpToMap
    }
  })], 1) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };